/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


export enum PartNumberChangesDetailFooterActionsEnum {
    CREATE = 'CREATE',
    DISCARD_CREATE = 'DISCARD_CREATE',
    SEND_TRIAL = 'SEND_TRIAL',
    DISCARD_TRIAL = 'DISCARD_TRIAL',
    CANCEL = 'CANCEL',
    ACCEPT = 'ACCEPT',
    REJECT = 'REJECT',
    SOLVE = 'SOLVE',
    DISCARD_SOLVE = 'DISCARD_SOLVE',
    SEND_SOLUTION = 'SEND_SOLUTION',
    DISCARD_SEND_SOLUTION = 'DISCARD_SEND_SOLUTION',
    SOLVE_AFTER_EE = 'SOLVE_AFTER_EE',
    DISCARD_SOLVE_AFTER_EE = 'DISCARD_SOLVE_AFTER_EE',
    ACCEPT_SOLUTION = 'ACCEPT_SOLUTION',
    REJECT_SOLUTION = 'REJECT_SOLUTION'
}
